import { RecordValue, StringValue } from '@coveo/bueno';
import { createAction } from '@reduxjs/toolkit';
import { requiredEmptyAllowedString, requiredNonEmptyString, validatePayload, } from '../../../utils/validate-payload.js';
const instantProductsIdDefinition = {
    id: requiredNonEmptyString,
};
const instantProductsQueryDefinition = {
    ...instantProductsIdDefinition,
    query: requiredEmptyAllowedString,
};
export const clearExpiredProducts = createAction('commerce/instantProducts/clearExpired', (payload) => validatePayload(payload, instantProductsIdDefinition));
const promoteChildToParentDefinition = {
    child: new RecordValue({
        options: { required: true },
        values: {
            permanentid: new StringValue({ required: true }),
        },
    }),
    ...instantProductsQueryDefinition,
};
export const promoteChildToParent = createAction('commerce/instantProducts/promoteChildToParent', (payload) => validatePayload(payload, promoteChildToParentDefinition));
export const registerInstantProducts = createAction('commerce/instantProducts/register', (payload) => validatePayload(payload, instantProductsIdDefinition));
export const updateInstantProductsQuery = createAction('commerce/instantProducts/updateQuery', (payload) => validatePayload(payload, instantProductsQueryDefinition));
